<template>
  <b-container>
    <b-form v-on:submit.prevent enctype="multipart/form-data">
      <b-row>
        <b-col cols="8">
          <b-card>
            <label for="items" class="text-primary font-weight-bolder mb-1"
              >Details</label
            >
            <b-row>
              <b-col cols="8">
                <b-form-group label="Vendor" label-for="vendor">
                  <v-select
                    id="vendor"
                    v-model="form.selectedVendor"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsVendor"
                    placeholder="Select 1 Vendor"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedVendor"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedVendor }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Is Warehouse" label-for="is_warehouse">
                  <v-select
                    id="is_warehouse"
                    v-model="form.selectedIsWarehouse"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsIsWarehouse"
                    placeholder="Is Warehouse"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedIsWarehouse"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedIsWarehouse }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="Description" label-for="description">
              <b-form-textarea
                id="description"
                placeholder="Description"
                v-model="form.description"
                required
              />
            </b-form-group>
            <b-row>
              <b-col cols="6" v-if="form.stateIsWarehouse === 1">
                <b-form-group label="Warehouse" label-for="warehouse">
                  <v-select
                    id="warehouse"
                    v-model="form.selectedWarehouse"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsWarehouse"
                    placeholder="Warehouse"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedWarehouse"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedWarehouse }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  :state="errors"
                  label="Attachment"
                  label-for="Attachment"
                  invalid-feedback="Attachment is required"
                >
                  <!-- <img id="display1" alt="display1" width="200" height="200" class="mb-1" :hidden="form.file1 ? false : true"> -->
                  <b-form-file
                    v-model="form.file1"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    accept="image/*, application/pdf"
                    onchange="document.getElementById('display1').src = window.URL.createObjectURL(this.files[0])"
                  />
                  <!-- Selected file: <strong>{{ form.file1 ? form.file1.name : '' }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="12" v-if="numberAttachment >= 1">
                <b-form-group
                  :state="errors"
                  label="Attachment 2"
                  label-for="Attachment_2"
                  invalid-feedback="Attachment is required"
                >
                  <!-- <img id="display2" alt="display2" width="200" height="200" class="mb-1" :hidden="form.file2 ? false : true"> -->
                  <b-form-file
                    v-model="form.file2"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    accept="image/*, application/pdf"
                    onchange="document.getElementById('display2').src = window.URL.createObjectURL(this.files[0])"
                  />
                  <!-- Selected file: <strong>{{ form.file2 ? form.file2.name : '' }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="12" v-if="numberAttachment >= 2">
                <b-form-group
                  :state="errors"
                  label="Attachment 3"
                  label-for="Attachment_3"
                  invalid-feedback="Attachment is required"
                >
                  <!-- <img id="display3" alt="display3" width="200" height="200" class="mb-1" :hidden="form.file3 ? false : true"> -->
                  <b-form-file
                    v-model="form.file3"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    accept="image/*, application/pdf"
                    onchange="document.getElementById('display3').src = window.URL.createObjectURL(this.files[0])"
                  />
                  <!-- Selected file: <strong>{{ form.file3 ? form.file3.name : '' }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="12" v-if="numberAttachment >= 3">
                <b-form-group
                  :state="errors"
                  label="Attachment 4"
                  label-for="Attachment_4"
                  invalid-feedback="Attachment is required"
                >
                  <!-- <img id="display4" alt="display4" width="200" height="200" class="mb-1" :hidden="form.file4 ? false : true"> -->
                  <b-form-file
                    v-model="form.file4"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    accept="image/*, application/pdf"
                    onchange="document.getElementById('display4').src = window.URL.createObjectURL(this.files[0])"
                  />
                  <!-- Selected file: <strong>{{ form.file4 ? form.file4.name : '' }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="12" v-if="numberAttachment >= 4">
                <b-form-group
                  :state="errors"
                  label="Attachment 5"
                  label-for="Attachment_5"
                  invalid-feedback="Attachment is required"
                >
                  <!-- <img id="display5" alt="display5" width="200" height="200" class="mb-1" :hidden="form.file5 ? false : true"> -->
                  <b-form-file
                    v-model="form.file5"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    accept="image/*, application/pdf"
                    onchange="document.getElementById('display5').src = window.URL.createObjectURL(this.files[0])"
                  />
                  <!-- Selected file: <strong>{{ form.file5 ? form.file5.name : '' }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="numberAttachment < 4" class="mb-1">
              <b-col md="12" class="mt-1">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="secondary"
                  class="mr-1"
                  block
                  @click="moreAttachment()"
                >
                  Add More Attachment
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <label for="items" class="text-primary font-weight-bolder mb-1"
              >Shipping</label
            >
            <b-row>
              <b-col cols="6">
                <b-form-group label="Shipping Date" label-for="shipping_date">
                  <flat-pickr
                    id="shipping_date"
                    v-model="form.shipping_date"
                    class="form-control"
                    placeholder="Shipping Date"
                  />
                  <!-- :config="{ dateFormat: 'd-m-Y'}" -->
                  <!-- <p>Value: '{{ form.shipping_date }}'</p> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group
              label="Shipping Address"
              label-for="shipping_address"
              class="mb-2"
            >
              <b-form-textarea
                id="shipping_address"
                placeholder="Shipping Address"
                v-model="form.shipping_address"
                required
              />
            </b-form-group>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card>
            <label for="items" class="text-primary font-weight-bolder mb-1"
              >Payment Info</label
            >
            <b-form-group label="Account" label-for="Account">
              <v-select
                id="Account"
                v-model="form.selectedAccount"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="text"
                :options="form.optionsAccount"
                placeholder="Select 1 Account"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!form.selectedAccount"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <!-- Selected: <strong>{{ form.selectedVendor }}</strong> -->
            </b-form-group>
            <hr class="my-2" />
            <b-form-group label="Tax" label-for="tax">
              <cleave
                id="tax"
                placeholder="Tax"
                v-model="form.tax"
                class="form-control"
                :raw="false"
                :options="options.number"
                required
              />
            </b-form-group>
            <b-form-group label="Additional Cost" label-for="additional_cost">
              <cleave
                id="additional_cost"
                placeholder="Additional Cost"
                v-model="form.additional_cost"
                class="form-control"
                :raw="false"
                :options="options.number"
                required
              />
            </b-form-group>
            <b-form-group label="Total Price" label-for="total_price">
              <cleave
                id="total_price"
                placeholder="Total Price"
                v-model="form.total_price"
                class="form-control"
                :raw="false"
                :options="options.number"
                disabled
              />
            </b-form-group>
            <hr class="my-2" />
            <b-form-group label="Term of payment" label-for="term_payment">
              <v-select
                id="term_payment"
                v-model="form.selectedTermPayment"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="text"
                :options="form.optionsTermPayment"
                placeholder="Select 1 Term Payment"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!form.selectedTermPayment"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <!-- Selected: <strong>{{ form.selectedTermPayment }}</strong> -->
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-row>
              <b-col>
                <label for="items" class="text-primary font-weight-bolder mb-1"
                  >Purchase Items</label
                >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  v-b-modal.modal-add
                  class="float-right mb-2"
                  >Add Item
                </b-button>
              </b-col>
            </b-row>
            <b-modal
              id="modal-add"
              ref="modal-add"
              centered
              title="Add Item"
              hide-footer
            >
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Product" label-for="product">
                    <v-select
                      id="product"
                      v-model="form2.selectedProduct"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="text"
                      :options="form2.optionsProduct"
                      placeholder="Select 1 Product"
                      :disabled="form.selectedVendor === null ? true : false"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                    <!-- Selected: <strong>{{ form2.selectedProduct }}</strong> -->
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Qty" label-for="qty">
                    <b-form-input
                      id="qty"
                      placeholder="Qty"
                      v-model="form2.qty"
                      type="number"
                      :disabled="form.selectedVendor === null ? true : false"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Price" label-for="price">
                    <cleave
                      id="price"
                      placeholder="Price"
                      v-model="form2.price"
                      class="form-control"
                      :raw="false"
                      :options="options.number"
                      :disabled="form.selectedVendor === null ? true : false"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="my-1"
                    @click="addItemToTable()"
                    block
                    :disabled="form.selectedVendor === null ? true : false"
                  >
                    Add Item
                  </b-button>
                </b-col>
              </b-row>
            </b-modal>
            <b-row>
              <b-col>
                <!-- table -->
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :rtl="direction"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Name -->
                    <span
                      v-if="props.column.field === 'name'"
                      class="text-nowrap"
                    >
                      <!-- <b-avatar
                                    :src="props.row.avatar"
                                    class="mx-1"
                                /> -->
                      <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Image -->
                    <span
                      v-else-if="props.column.field === 'image'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap"
                        ><img :src="props.row.image" alt="items" width="50"
                      /></span>
                    </span>

                    <!-- Column: Price -->
                    <span
                      v-else-if="props.column.field === 'price'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap">Rp {{ props.row.price }}</span>
                    </span>

                    <!-- Column: Status -->
                    <span v-else-if="props.column.field === 'status'">
                      <b-badge :variant="statusVariant(props.row.status)">
                        <span v-if="props.row.status === 1">Active</span>
                        <span v-else>Non-Active</span>
                      </b-badge>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                      <span>
                        <b-dropdown
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                        >
                          <template v-slot:button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="text-body align-middle mr-25"
                            />
                          </template>
                          <b-dropdown-item
                            @click="
                              deleteItemFromTable(props.row.originalIndex)
                            "
                          >
                            <feather-icon icon="TrashIcon" class="mr-50" />
                            <span>Delete</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>

                  <!-- pagination -->
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Showing 1 to </span>
                        <b-form-select
                          v-model="pageLength"
                          :options="['3', '5', '10']"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({ currentPerPage: value })
                          "
                        />
                        <span class="text-nowrap">
                          of {{ props.total }} entries
                        </span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="validation()"
            block
            :disabled="rows.length === 0 ? true : false"
          >
            Submit
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BModal,
  VBModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import { integer } from "vee-validate/dist/rules";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
    BModal,
    VBModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        selectedVendor: null,
        optionsVendor: [],
        total_price: 0,
        tax: 0,
        additional_cost: 0,
        file1: null,
        file2: null,
        file3: null,
        file4: null,
        file5: null,
        selectedAccount: null,
        optionsAccount: [],
        description: "",
        shipping_address: "",
        shipping_date: null,
        selectedTermPayment: null,
        optionsTermPayment: [],
        selectedIsWarehouse: null,
        optionsIsWarehouse: [
          { value: 0, text: "No" },
          { value: 1, text: "Yes" },
        ],
        selectedWarehouse: null,
        optionsWarehouse: [],
        stateIsWarehouse: null,
      },
      form2: {
        purchase_id: null,
        selectedProduct: null,
        optionsProduct: [],
        qty: null,
        price: null,
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      numberAttachment: 0,
      hasImage: "",
      image: "",
      photo: "",
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Image",
          field: "image",
        },
        {
          label: "Code",
          field: "code",
        },
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Qty",
          field: "qty",
        },
        {
          label: "Unit",
          field: "unit_name",
        },
        {
          label: "Price",
          field: "price",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: [],
      searchTerm: "",
      errors: "",
      errMessage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-success",
        0: "light-danger",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  watch: {
    rows: function ($data) {
      this.triggerTotalPrice($data);
    },
    "form.tax": function ($data) {
      if ($data === "") {
        this.form.tax = 0;
      } else {
        this.triggerTax($data);
      }
    },
    "form.additional_cost": function ($data) {
      if ($data === "") {
        this.form.additional_cost = 0;
      } else {
        this.triggerAdditionalCost($data);
      }
    },
    "form.selectedVendor": function (data) {
      this.form2.selectedProduct = null;
      this.form2.optionsProduct.splice(0);
      this.form2.qty = null;
      this.form2.price = null;
      this.getProduct(data.value);
    },
    "form.selectedIsWarehouse": function ($data) {
      this.form.stateIsWarehouse = $data.value;
    },
  },
  created() {
    this.getVendor();
    this.getAccount();
    this.getTermPayment();
    this.getWarehouse();
  },
  methods: {
    getVendor() {
      this.$http.get("procurement/vendors").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsVendor.push($data);
        }
        // console.log(this.form.optionsVendor)
      });
    },
    getAccount() {
      this.$http.get("finance/accounts").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsAccount.push($data);
        }
        // console.log(this.form.optionsAccount)
      });
    },
    getTermPayment() {
      this.$http.get("procurement/term-payments").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsTermPayment.push($data);
        }
        // console.log(this.form.optionsTermPayment)
      });
    },
    getWarehouse() {
      this.$http.get("warehouses").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsWarehouse.push($data);
        }
        // console.log(this.form.optionsWarehouse)
      });
    },
    getProduct(id) {
      this.$http
        .get("products" + (id ? "?vendor=" + id : ""))
        .then((response) => {
          // console.log(response.data.data)
          var datas = response.data.data;
          var i;
          for (i = 0; i < datas.length; i++) {
            const { baseUrl } = $themeConfig.app;
            this.photo = baseUrl;
            this.photo += "storage/product/";
            this.photo += datas[i].image;

            var $data = {
              value: datas[i].id,
              text: datas[i].name,
              code: datas[i].code,
              unit: datas[i].unit_name,
              urlImage: this.photo,
            };
            // console.log($data)
            this.form2.optionsProduct.push($data);
          }
          // console.log(this.form2.optionsProduct)
        });
    },
    moreAttachment() {
      this.numberAttachment += 1;
    },
    triggerTotalPrice($datas) {
      var i;
      this.form.total_price = 0;
      for (i = 0; i < $datas.length; i++) {
        var newPrice = $datas[i].price;
        newPrice = newPrice.replace(/\,/g, "");
        this.form.total_price += $datas[i].qty * newPrice;
      }
      var newTax = this.form.tax;
      newTax = newTax.replace(/\,/g, "");
      var newAdditionalCost = this.form.additional_cost;
      newAdditionalCost = newAdditionalCost.replace(/\,/g, "");
      var $cost = parseInt(newTax) + parseInt(newAdditionalCost);
      this.form.total_price = this.form.total_price + $cost;
    },
    triggerTax($data) {
      var newTax = $data;
      newTax = newTax.replace(/\,/g, "");
      var newAdditionalCost = this.form.additional_cost;
      newAdditionalCost = newAdditionalCost.replace(/\,/g, "");
      this.triggerTotalPrice(this.rows);
      var newTotalPrice = this.form.total_price;
      newTotalPrice = newTotalPrice.replace(/\,/g, "");
      this.form.total_price =
        parseInt(newTax) +
        parseInt(newAdditionalCost) +
        parseInt(newTotalPrice);
    },
    triggerAdditionalCost($data) {
      var newAdditionalCost = $data;
      newAdditionalCost = newAdditionalCost.replace(/\,/g, "");
      var newTax = $data;
      newTax = newTax.replace(/\,/g, "");
      this.triggerTotalPrice(this.rows);
      var newTotalPrice = this.form.total_price;
      newTotalPrice = newTotalPrice.replace(/\,/g, "");
      this.form.total_price =
        parseInt(newAdditionalCost) +
        parseInt(newAdditionalCost) +
        parseInt(newTotalPrice);
    },
    addItemToTable() {
      this.$refs["modal-add"].hide();
      if (this.form2.selectedProduct === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Product field is required",
            variant: "warning",
          },
        });
      } else if (this.form2.qty === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Qty field is required",
            variant: "warning",
          },
        });
      } else if (this.form2.price === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Price field is required",
            variant: "warning",
          },
        });
      } else {
        var $data = {
          id: this.form2.selectedProduct.value,
          image: this.form2.selectedProduct.urlImage,
          code: this.form2.selectedProduct.code,
          name: this.form2.selectedProduct.text,
          unit_name: this.form2.selectedProduct.unit,
          qty: this.form2.qty,
          price: this.form2.price,
        };
        this.rows.push($data);
        this.form2.selectedProduct = null;
        this.form2.qty = null;
        this.form2.price = null;
      }
    },
    deleteItemFromTable(index) {
      this.rows.splice(index, 1);
    },
    validation() {
      if (this.form.selectedVendor === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Vendor field is required",
            variant: "warning",
          },
        });
      } else if (this.form.total_price === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Total Price field is required",
            variant: "warning",
          },
        });
      } else if (this.form.tax === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Tax field is required",
            variant: "warning",
          },
        });
      } else if (this.form.additional_cost === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Additional Cost field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedAccount === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Account field is required",
            variant: "warning",
          },
        });
      } else if (this.form.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else if (this.form.shipping_address === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Shipping Address field is required",
            variant: "warning",
          },
        });
      } else if (this.form.shipping_date === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Shipping Date field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedTermPayment === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Term Payment field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedIsWarehouse === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Is Warehouse field is required",
            variant: "warning",
          },
        });
      } else {
        if (this.form.stateIsWarehouse === 1) {
          if (this.form.selectedWarehouse === null) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Notification",
                icon: "BellIcon",
                text: "The Warehouse field is required",
                variant: "warning",
              },
            });
          } else {
            this.addPurchase();
          }
        } else {
          this.addPurchase();
        }
      }
    },
    addPurchase() {
      var newTotalPrice = this.form.total_price;
      newTotalPrice = newTotalPrice.replace(/\,/g, "");
      var newTax = this.form.tax;
      newTax = newTax.replace(/\,/g, "");
      var newAdditionalCost = this.form.additional_cost;
      newAdditionalCost = newAdditionalCost.replace(/\,/g, "");
      let formData = new FormData();
      formData.append("vendor_id", this.form.selectedVendor.value);
      formData.append("total_price", newTotalPrice);
      formData.append("tax", newTax);
      formData.append("additional_cost", newAdditionalCost);
      if (this.form.file1 !== null) {
        formData.append("attachment_1", this.form.file1);
      }
      if (this.form.file2 !== null) {
        formData.append("attachment_2", this.form.file2);
      }
      if (this.form.file3 !== null) {
        formData.append("attachment_3", this.form.file3);
      }
      if (this.form.file4 !== null) {
        formData.append("attachment_4", this.form.file4);
      }
      if (this.form.file5 !== null) {
        formData.append("attachment_5", this.form.file5);
      }
      formData.append("account_id", this.form.selectedAccount.value);
      formData.append("description", this.form.description);
      formData.append("shipping_address", this.form.shipping_address);
      formData.append("shipping_date", this.form.shipping_date);
      formData.append("term_payment", this.form.selectedTermPayment.value);
      formData.append("is_warehouse", this.form.selectedIsWarehouse.value);
      if (this.form.stateIsWarehouse === 1) {
        formData.append("warehouse_id", this.form.selectedWarehouse.value);
      }
      this.$http
        .post("procurement/purchase/add", formData)
        .then((response) => {
          this.form2.purchase_id = response.data.data.id;
          var $datas = this.rows;
          var i;
          for (i = 0; i < $datas.length; i++) {
            var newPrice = $datas[i].price;
            newPrice = newPrice.replace(/\,/g, "");
            var $data = {
              purchase_id: this.form2.purchase_id,
              product_id: $datas[i].id,
              qty: $datas[i].qty,
              price: newPrice,
            };
            // console.log($data)
            this.addPurchaseItems($data);
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success add Purchase",
              variant: "success",
            },
          });
          setTimeout(function () {
            location.href = "/procurement/purchase";
          }, 2000);
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    addPurchaseItems($data) {
      this.$http
        .post("procurement/purchase/item/add", $data)
        .then((response) => {
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style>
#purchase div img.img-preview {
  width: 200px;
  padding-right: 10px;
}
</style>